import { render } from "./Chanpin.vue?vue&type=template&id=5792f825&scoped=true"
import script from "./Chanpin.vue?vue&type=script&lang=js"
export * from "./Chanpin.vue?vue&type=script&lang=js"

import "./Chanpin.vue?vue&type=style&index=0&id=5792f825&scoped=true&lang=css"

import exportComponent from "D:\\lxq\\nkpcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5792f825"]])

export default __exports__